import { render, staticRenderFns } from "./confirmPlaceOrder.vue?vue&type=template&id=2c64fc9d&scoped=true"
import script from "./confirmPlaceOrder.vue?vue&type=script&lang=js"
export * from "./confirmPlaceOrder.vue?vue&type=script&lang=js"
import style0 from "./confirmPlaceOrder.vue?vue&type=style&index=0&id=2c64fc9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c64fc9d",
  null
  
)

export default component.exports